/**
 * Markets allowed per ref entry-point value (iso2 codes).
 * When a ref has no entry here, all markets remain available.
 */
export const REF_MARKET_RESTRICTIONS = {
  somastem: ['US', 'CA'],
};
